import { ajax } from "@utils";

export const authService = {
  /**
   * 登入
   * @key LoginByProperty
   * @param {string} constructionuuid - 建案 uuid
   * @param {string} password - 密碼
   * @param {string} token - recapcha token
   * @returns
   */
  login: (constructionuuid, password, token) => {
    return ajax
      .post(`${process.env.REACT_APP_API_URL}/property/auth/login`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          construction_uuid: constructionuuid,
          password,
          recaptcha_token: token
        }),
        isWithToken: false
      })
      .then(response => response.json())
      .then(
        res => {
          if (res.status !== 200) {
            return Promise.reject(res);
          }

          return res.data;
        },
        err => {
          return Promise.reject({ message: err });
        }
      );
  },
  /**
   * 檢查登入狀態
   * @key AuthenticateByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @returns
   */
  check: constructionUuid => {
    return ajax
      .post(`${process.env.REACT_APP_API_URL}/property/auth/authenticate`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          construction_uuid: constructionUuid
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res);
        }

        return res.data;
      });
  }
};
